<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="80%">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="hidden-sm-and-down" v-bind="attrs" v-on="on" color="primary" dark
          :disabled="!plano.id || !plano.ativo" alt="Incluir Recesso"
          @click="abrirCadastro()" title="Incluir Recesso">
          <v-icon>add</v-icon>Incluir
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form">
              <v-layout wrap>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Ano" disabled :value="plano.ano"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Número" disabled :value="plano.numero"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Data Início" disabled :value="plano.dataInicio"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Data Fim" disabled :value="plano.dataFim"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field color="primary" label="Descrição do Plano" disabled :value="plano.descricao"></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider class="my-3"></v-divider>
              <v-layout wrap>
                <v-flex xs12 sm6 md3>
                  <date-picker-custom label="Data" :v-model="recesso.data" @date="onDataChange"
                    :error-messages="fieldErrors('recesso.data')"></date-picker-custom>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Dia Semana" disabled :value="diaSemana"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 v-if="editando">
                  <v-select v-model="recesso.idTipoFuncao" :items="tiposFuncao" item-text="nome" item-value="id"
                    label="Função" :error-messages="fieldErrors('recesso.idTipoFuncao')"
                    @blur="$v.recesso.idTipoFuncao.$touch()"></v-select>
                </v-flex>
                <v-flex xs12 sm6 md3 v-else>
                  <v-select v-model="idsTipoFuncao" :items="tiposFuncao" item-text="nome" item-value="id"
                    label="Função" multiple chips :error-messages="erroFuncoesSelecionadas"></v-select>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field v-model="recesso.descricao" :error-messages="fieldErrors('recesso.descricao')"
                    @blur="$v.recesso.descricao.$touch()" label="Descrição" maxlength="50"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="close">Cancelar</v-btn>
          <v-btn color="primary" type="submit" @click.native="confirmar" dark>{{ btnTitle }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import qhRecessoService from "@/service/qh/QhRecessoService";
import QhRecesso from "@/model/qh/QhRecesso";
import DatePickerCustom from "@/components/Custom/DatePickerCustom";
import { required, maxLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import messageMixin from "@/mixins/message";
import EventBus from "@/utils/EventBus";

const DIAS_SEMANA = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];

export default {
  name: "ModalCadastroQhRecesso",
  components: { DatePickerCustom },
  props: {
    plano: { type: Object, default: () => ({}) }
  },
  mixins: [validationMixin, messageMixin],
  validations: {
    recesso: QhRecesso.validations(required, maxLength)
  },
  validationMessages: {
    recesso: QhRecesso.validationMessages()
  },
  data() {
    return {
      dialog: false,
      formTitle: "",
      btnTitle: "",
      editando: false,
      tiposFuncao: [],
      idsTipoFuncao: [],
      tentouSalvar: false,
      recesso: new QhRecesso()
    };
  },
  computed: {
    diaSemana() {
      if (!this.recesso.data) return "";
      const [dia, mes, ano] = String(this.recesso.data).split("/");
      if (!dia || !mes || !ano) return "";
      const d = new Date(`${ano}-${mes}-${dia}T00:00:00`);
      if (isNaN(d.getTime())) return "";
      return DIAS_SEMANA[d.getDay()];
    },
    erroFuncoesSelecionadas() {
      if (!this.tentouSalvar) return [];
      return this.idsTipoFuncao && this.idsTipoFuncao.length > 0
        ? []
        : ["Selecione ao menos uma função"];
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    EventBus.$on("editaQhRecesso", async idRecesso => {
      await this.carregarTipos();
      const linha = await qhRecessoService.buscarPorId(idRecesso);
      if (!linha) return;
      this.formTitle = "Alterar Recesso Quadro Horário";
      this.btnTitle = "Alterar";
      this.editando = true;
      this.idsTipoFuncao = [];
      this.recesso = new QhRecesso({
        id: linha.id,
        idQhPlano: this.plano.id,
        data: linha.data,
        idTipoFuncao: linha.idTipoFuncao,
        descricao: linha.descricao
      });
      this.dialog = true;
    });
  },
  methods: {
    async carregarTipos() {
      if (this.tiposFuncao.length === 0) {
        this.tiposFuncao = await qhRecessoService.listarTiposFuncao();
      }
    },
    async abrirCadastro() {
      await this.carregarTipos();
      this.formTitle = "Incluir Recesso Quadro Horário";
      this.btnTitle = "Salvar";
      this.editando = false;
      this.idsTipoFuncao = [];
      this.tentouSalvar = false;
      this.recesso = new QhRecesso();
      this.recesso.idQhPlano = this.plano.id;
      this.dialog = true;
    },
    onDataChange(novaData) {
      this.recesso.data = novaData;
    },
    async confirmar() {
      this.tentouSalvar = true;
      this.$v.recesso.$touch();
      // RN10.3.2 (#152) — na inclusão a função é multi-seleção; idTipoFuncao
      // (campo único do modelo) é definido a cada iteração antes do POST.
      if (!this.editando) {
        const dataInvalida =
          !this.recesso.data ||
          !this.recesso.descricao ||
          this.$v.recesso.descricao.$invalid ||
          this.$v.recesso.data.$invalid;
        if (dataInvalida || this.idsTipoFuncao.length === 0) {
          return;
        }
        this.recesso.idQhPlano = this.plano.id;
        let algumErro = false;
        for (const idFuncao of this.idsTipoFuncao) {
          const recessoPorFuncao = new QhRecesso({
            ...this.recesso,
            id: null,
            idTipoFuncao: idFuncao
          });
          const retorno = await qhRecessoService.salvar(recessoPorFuncao);
          if (!retorno) {
            algumErro = true;
            break;
          }
        }
        if (!algumErro) {
          this.$emit("qhRecessoCadastrado", true);
          this.close();
        }
        return;
      }
      // Edição: comportamento original (1 registro só)
      if (this.$v.$invalid) {
        return;
      }
      this.recesso.idQhPlano = this.plano.id;
      qhRecessoService.salvar(this.recesso).then(retorno => {
        if (retorno) {
          this.$emit("qhRecessoCadastrado", true);
          this.close();
        }
      });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$v.$reset();
        this.recesso = new QhRecesso();
        this.idsTipoFuncao = [];
        this.editando = false;
        this.tentouSalvar = false;
        EventBus.$emit("resetCustom");
      }, 300);
    }
  }
};
</script>
